import fetch from 'logic/rest/FetchProvider';
import { qualifyUrl } from 'util/URLUtils';
import EnterpriseApiRoutes from 'common/ApiRoutes';

export default function getEventTypeCategories() {
  return fetch('get', qualifyUrl(EnterpriseApiRoutes.ContentUI.eventTypeCategory().url));
}
